// Extrae tablas del HTML que Outlook pone en el portapapeles (text/html) usando DOMParser.
// Sólo se conserva TEXTO de celdas (nunca HTML crudo). Devuelve [{cabeceras, filas, n_filas}].
export function tablasDesdeHtml(html) {
  if (!html || !/<table/i.test(html)) return [];
  let doc;
  try {
    doc = new DOMParser().parseFromString(html, "text/html");
  } catch {
    return [];
  }
  const out = [];
  doc.querySelectorAll("table").forEach((table) => {
    if (table.querySelector("table")) return; // tabla de layout que envuelve otra: usar la interna
    const filas = [];
    table.querySelectorAll("tr").forEach((tr) => {
      const celdas = Array.from(tr.querySelectorAll("td,th")).map((td) => (td.textContent || "").replace(/\s+/g, " ").trim());
      if (celdas.length >= 2 && celdas.some(Boolean)) filas.push(celdas);
    });
    if (filas.length >= 2) out.push({ cabeceras: filas[0], filas: filas.slice(1), n_filas: filas.length - 1 });
  });
  return out;
}

export const esPerfilDecorGalva = (cliente) => /decor\s*galv/i.test(`${cliente?.nombre || ""} ${cliente?.razon_social || ""}`);
